import React from "react";
import { BasketIcon } from "~/common/icons/BasketIcon";
import { Logger } from "~/utils/logger";
const logger = new Logger("basket", "info");

export function Basket(props: {
  size: number;
  basket_color: string;
  basket_bg_color: string;
  scroll_effect: "yes" | "no" | "";
  scroll_visibility: "show" | "hide";
  scroll_offset: number;
}) {
  const BASKET_COUNT_KEY = "glCount";
  const basketUrl = Environment.CN_URL + "/basket/checkout?cntoken=1";

  const basketCount = localStorage.getItem(BASKET_COUNT_KEY) || "0";
  logger.info("basketUrl ", basketUrl);

  // if the scroll_effect is enabled, we use the scroll_visibility setting
  // to determine the initial visibility of the basket and then toggle visibility
  // based on the scroll offset. If scroll_effect is not enabled, the basket is always visible.
  function initialVisibility() {
    if (props.scroll_effect !== "yes") {
      return true; // Always visible if scroll effect is not enabled
    }

    return props.scroll_visibility !== "show"; // initial visibility is opposite of scroll_visibility setting
  }

  const [isVisible, setIsVisible] = React.useState(initialVisibility());

  logger.debug("props:", props);

  React.useEffect(() => {
    if (props.scroll_effect !== "yes") {
      return;
    }

    // display the cart on the bottom header when scrolling down
    // since the top header becomes hidden
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      if (currentScrollPos === 0) {
        setIsVisible(props.scroll_visibility !== "show");
      }

      if (currentScrollPos > props.scroll_offset) {
        setIsVisible(props.scroll_visibility === "show");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [props.scroll_effect, props.scroll_visibility, props.scroll_offset]);

  return isVisible ? (
    <a href={basketUrl}>
      <div
        className="tw:rounded-full tw:cursor-pointer tw:flex tw:justify-center tw:items-center"
        style={{
          backgroundColor: props.basket_bg_color,
          height: `${props.size}px`,
          width: `${props.size}px`,
        }}
      >
        <BasketIcon
          style={{
            color: props.basket_color,
            width: `${props.size / 2}px`,
            height: `${props.size / 2}px`,
          }}
        />
        {/* Display the basket count in the center of the basket icon */}
        <span
          className="tw:flex tw:justify-center tw:items-center"
          style={{
            position: "absolute",
            top: `${0}px`,
            bottom: `${2}px`,
            left: `${0}px`,
            right: `${0}px`,
            fontSize: `${props.size / 4}px`,
            color:
              props.basket_bg_color === "" ? "white" : props.basket_bg_color,
          }}
        >
          {basketCount}
        </span>
      </div>
    </a>
  ) : null;
}
